export const UI_BASE_PATH = "";

export default UI_BASE_PATH;
